var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticStyle:{"min-height":"100vh"}},[_c('router-view')],1),_vm._v(" "),_c('vue-slideout-panel'),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),_c('modals-container'),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }